module.exports = __webpack_public_path__ + "img/hero_image_branches_v2.3ca820c.jpg";